export default "__VITE_ASSET__C7uOroof__"